import React, { useState } from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import { Avatar, IconButton, Stack, TextField } from "@mui/material";
import { SendIcon } from "assets/material-custom-icons";

interface Props {
  currentUserAvatarUrl?: string;
  onSend: (text: string) => void;
  onCancel: () => void;
}

export const ReplyInput: React.FC<Props> = ({ currentUserAvatarUrl, onSend, onCancel }) => {
  const [replyText, setReplyText] = useState("");

  const handleSend = () => {
    if (replyText.trim()) {
      onSend(replyText.trim());
      setReplyText("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleCancel = () => {
    setReplyText("");
    onCancel();
  };

  return (
    <Stack direction="row" gap="10px" alignItems="flex-start" sx={{ py: "10px", pl: "50px" }}>
      <Avatar
        src={currentUserAvatarUrl}
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          flexShrink: 0,
          mt: "8px"
        }}
      />
      <Stack direction="row" gap="8px" alignItems="flex-start" sx={{ flex: 1 }}>
        <TextField
          placeholder="Type a reply"
          value={replyText}
          onChange={(e) => setReplyText(e.target.value)}
          onKeyPress={handleKeyPress}
          fullWidth
          multiline
          minRows={1}
          maxRows={4}
          variant="outlined"
          autoFocus
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              fontSize: "16px",
              alignItems: "flex-start",
              "& fieldset": {
                borderColor: "#7b92a9"
              },
              "&:hover fieldset": {
                borderColor: "#7b92a9"
              },
              "&.Mui-focused fieldset": {
                borderColor: "#7b92a9"
              },
              "&.MuiInputBase-multiline": {
                paddingTop: "8px",
                paddingBottom: "8px"
              }
            },
            "& .MuiInputBase-input": {
              py: 0,
              px: "8px",
              fontSize: "16px",
              lineHeight: "24px",
              color: "#071f35",
              "&::placeholder": {
                color: "#92a7bc",
                opacity: 1
              }
            },
            "& .MuiInputBase-inputMultiline": {
              paddingTop: 0,
              paddingBottom: 0
            }
          }}
          InputProps={{
            endAdornment: (
              <IconButton
                onClick={handleSend}
                disabled={!replyText.trim()}
                sx={{
                  width: 24,
                  height: 24,
                  p: 0,
                  color: replyText.trim() ? "#496682" : "#92a7bc",
                  alignSelf: "flex-end",
                  mt: "8px"
                }}
              >
                <SendIcon sx={{ fontSize: "24px" }} />
              </IconButton>
            )
          }}
        />
        <IconButton
          onClick={handleCancel}
          sx={{
            width: 24,
            height: 24,
            p: 0,
            color: "#92a7bc",
            mt: "8px",
            flexShrink: 0,
            "&:hover": {
              color: "#496682"
            }
          }}
        >
          <CancelIcon sx={{ fontSize: "24px" }} />
        </IconButton>
      </Stack>
    </Stack>
  );
};

